/**
 * MS-591 — the acceptance line on the signed agreement page.
 *
 * The backend formats both halves in KSA time with the same helper the confirmation email
 * uses, so the page and the email cannot disagree. They are printed verbatim: no dayjs, no
 * timezone conversion, no locale reformatting. When either half is absent the whole line is
 * omitted rather than rendered with a gap — MS-581 returns null (not an empty string) for
 * exactly this, and a half-stated legal timestamp is worse than none.
 *
 * The separator is the Figma's middle dot, matching the signed agreement row on the payment
 * page verbatim. The MS-591 ticket text describes a sentence form ("تمت الموافقة بتاريخ …،
 * الساعة …") instead; the Figma is the source of truth, and the two surfaces showing the same
 * consent record are meant to read identically.
 */
export function signedAtLine(
  date: string | null | undefined,
  time: string | null | undefined
): string | null {
  if (!date?.trim() || !time?.trim()) return null;

  return `${date} · ${time}`;
}
